import {
  FETCH_ALL_USERS,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILED,
  EDIT_USER,
  EDIT_USER_SUCCESS,
  EDIT_USER_FAILED,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  FETCH_ALL_USERS_STATIC,
  FETCH_ALL_USERS_STATIC_SUCCESS,
  FETCH_ALL_USERS_STATIC_FAILED,
  USER_DELETED,
  FETCH_ALL_DRIVERS,
  FETCH_ALL_DRIVERS_SUCCESS,
  FETCH_ALL_DRIVERS_FAILED
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set, push, update, off, get, remove } from "firebase/database";
import { isDriverEligible } from '../other/driverEligibility';
import { uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { signOut } from "firebase/auth";

export const fetchUsers = () => (dispatch) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_DRIVERS,
    payload: null
  });
  onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);
      const locations = locationdata.val();
      const data = snapshot.val();
      const arr = Object.keys(data)
      .filter(i => data[i].usertype!='admin')
      .map(i => {
        data[i].id = i;
        data[i].location = locations && locations[i] ? locations[i] : null;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_ALL_USERS_FAILED,
        payload: "No users available."
      });
    }
  });
};


export const fetchUsersOnce = () => (dispatch) => {

  const {
    usersRef,
    allLocationsRef
  } = firebase;

  dispatch({
    type: FETCH_ALL_USERS_STATIC,
    payload: null
  });
  onValue(usersRef, async snapshot => {
    if (snapshot.val()) {
      const locationdata = await get(allLocationsRef);
      const locations = locationdata.val();
      const data = snapshot.val();
      const arr = Object.keys(data)
      .map(i => {
        data[i].id = i;
        data[i].location = locations && locations[i] ? locations[i] : null;
        return data[i];
      });
      dispatch({
        type: FETCH_ALL_USERS_STATIC_SUCCESS,
        payload: arr
      })
    } else {
      dispatch({
        type: FETCH_ALL_USERS_STATIC_FAILED,
        payload: "No users available."
      });
    }
  },{onlyOnce: true});
  
};
export const clearFetchDrivers = () => (dispatch) => {
  const {
    driversRef,
    allLocationsRef,
  } = firebase;
  off(driversRef);
  off(allLocationsRef);
}

export const fetchDrivers = (appType) => async(dispatch) => {

  const {
    driversRef,
    allLocationsRef,
    settingsRef,
  } = firebase;

  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();

  dispatch({
    type: FETCH_ALL_USERS,
    payload: null
  });

  // B-5 fix: nested onValue kaldırıldı. Eski hali driversRef HER tetiklendiğinde
  // YENİ bir allLocationsRef listener kuruyordu — realtime modda kalıcı listener'lar
  // birikiyordu (admin panel sızıntısı). Artık iki listener bağımsız; ortak recompute()
  // en güncel iki snapshot'ı birleştirir. İlk dispatch için ikisi de yüklenene dek beklenir
  // (boş liste flash'ı önlenir — eski nested davranışı korunur).
  const opts = appType === 'app' ? { onlyOnce: true } : (settings && settings.realtime_drivers ? null : { onlyOnce: true });

  let latestDrivers = null;
  let latestLocations = null;
  let driversLoaded = false;
  let locsLoaded = false;

  const recompute = () => {
    if (!driversLoaded || !locsLoaded) return; // ilk dispatch öncesi ikisini de bekle
    if (!latestDrivers) {
      dispatch({ type: FETCH_ALL_DRIVERS_FAILED, payload: "No users available." });
      return;
    }
    const data = latestDrivers;
    const locations = latestLocations;
    // K8 (2026-05-28): eligibility shared doc-verification gate (driverEligibility.js).
    const arr = Object.keys(data)
      .filter(i => data && isDriverEligible(data[i]) && locations && locations[i])
      .map(i => ({
        id: i,
        location: locations && locations[i] ? locations[i] : null,
        carType: data[i].carType ? data[i].carType : null,
        vehicleNumber: data[i].vehicleNumber ? data[i].vehicleNumber : null,
        firstName: data[i].firstName,
        lastName: data[i].lastName,
        queue: data[i].queue
      }));
    dispatch({ type: FETCH_ALL_DRIVERS_SUCCESS, payload: arr });
  };

  off(driversRef);
  off(allLocationsRef);
  onValue(driversRef, snapshot => { latestDrivers = snapshot.val(); driversLoaded = true; recompute(); }, opts);
  onValue(allLocationsRef, locres => { latestLocations = locres.val(); locsLoaded = true; recompute(); }, opts);
};

export const addUser = (userdata) => (dispatch) => {
  const {
    usersRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: userdata
  });

  delete userdata.tableData;

  push(usersRef, userdata).then(() => {
    dispatch({
      type: EDIT_USER_SUCCESS,
      payload: null
    });
  }).catch((error) => {
    dispatch({
      type: EDIT_USER_FAILED,
      payload: error
    });
  });
}

export const editUser = (id, user) => (dispatch) => {

  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: user
  });
  let editedUser = { ...user };
  delete editedUser.id;
  delete editedUser.tableData;
  // 2026-05-29 fix(auth-loading): `set(singleUserRef(id), ...)` clobbers the
  // ENTIRE /users/<uid> node and is denied with permission_denied whenever
  // the payload silently re-asserts a child key whose own `.write` rule
  // requires a stricter caller (walletBalance, usertype). Using `update`
  // applies a multi-path merge — each child path is evaluated against its
  // own rule, so a no-op re-write of restricted keys still goes through
  // without denying the entire patch. This also prevents accidental data
  // loss when stale tableData / id / undefined fields are reset.
  update(singleUserRef(id), editedUser);
}

export const updateUserCar = (id, data) => (dispatch) => {
  const {
    singleUserRef
  } = firebase;

  dispatch({
    type: EDIT_USER,
    payload: data  
  });
  update(singleUserRef(id),data);
}

export const updateLicenseImage = (uid, imageBlob, imageType) => async (dispatch) => {

  const {
    singleUserRef,
    driverDocsRef,
    driverDocsRefBack,
    verifyIdImageRef
  } = firebase;

  let profile = {};
  if(imageType === 'licenseImage'){
    await uploadBytesResumable(driverDocsRef(uid),imageBlob);
    let image = await getDownloadURL(driverDocsRef(uid));
    profile.licenseImage = image;
  }
  if(imageType === 'licenseImageBack'){
    await uploadBytesResumable(driverDocsRefBack(uid),imageBlob);
    let image1 = await getDownloadURL(driverDocsRefBack(uid));
    profile.licenseImageBack = image1;
  }
  if(imageType === 'verifyIdImage'){
    await uploadBytesResumable(verifyIdImageRef(uid),imageBlob);
    let image1 = await getDownloadURL(verifyIdImageRef(uid));
    profile.verifyIdImage = image1;
  }
  update(singleUserRef(uid),profile);
  dispatch({
    type: EDIT_USER,
    payload: uid
  });
};

export const updateDriverDoc = (uid, imageBlob, docType) => async (dispatch) => {
  const {
    driverDocRef,
    driverDocMetaRef
  } = firebase;

  await uploadBytesResumable(driverDocRef(uid, docType), imageBlob);
  const url = await getDownloadURL(driverDocRef(uid, docType));
  const meta = {
    url,
    uploadedAt: new Date().getTime(),
    verified: false,
    docType
  };
  await set(driverDocMetaRef(uid, docType), meta);
  dispatch({
    type: EDIT_USER,
    payload: uid
  });
  return meta;
};

export const updateDriverDocField = (uid, docType, fieldUpdates) => async (dispatch) => {
  const { driverDocMetaRef } = firebase;
  if (!fieldUpdates || typeof fieldUpdates !== 'object') return null;
  await update(driverDocMetaRef(uid, docType), fieldUpdates);
  dispatch({
    type: EDIT_USER,
    payload: uid
  });
  return fieldUpdates;
};

export const updateBankInfo = (uid, iban, holderName, statementBlob, options) => async (dispatch) => {
  const {
    bankInfoRef,
    bankStatementRef
  } = firebase;
  const isPendingChange = !!(options && options.asPendingChange);
  let statementUrl = (options && options.existingStatementUrl) || null;
  if (statementBlob) {
    await uploadBytesResumable(bankStatementRef(uid), statementBlob);
    statementUrl = await getDownloadURL(bankStatementRef(uid));
  }
  const payload = {
    iban: String(iban || '').replace(/\s+/g, '').toUpperCase(),
    holderName: holderName || '',
    statementUrl,
    status: 'pending',
    addedAt: new Date().getTime(),
    rejectionReason: null
  };
  if (isPendingChange) {
    // Onaylı IBAN aktif kalsın, yeni başvuru pendingBank altına yazılır
    const { singleUserRef } = firebase;
    await update(singleUserRef(uid), { pendingBank: payload });
  } else {
    await set(bankInfoRef(uid), payload);
  }
  dispatch({
    type: EDIT_USER,
    payload: uid
  });
  return payload;
};

export const verifyDriverDoc = (uid, docType, verified, reason) => async (dispatch) => {
  const { driverDocMetaRef } = firebase;
  const payload = {
    verified: !!verified,
    reviewedAt: new Date().getTime()
  };
  if (typeof reason === 'string' && reason.length > 0) {
    payload.rejectionReason = reason;
  } else {
    payload.rejectionReason = null;
  }
  await update(driverDocMetaRef(uid, docType), payload);
  dispatch({
    type: EDIT_USER,
    payload: uid
  });
  return payload;
};

// K8d: explicit consent capture. `consents` node shape:
//   consents/{type} = { accepted: true, version, acceptedAt }
// Types: 'tos' (Kullanım Şartları), 'kvkk' (KVKK), 'courier' (Bağımsız Kurye Sözleşmesi).
// Registration captures tos+kvkk; the driver onboarding/MapScreen capture happens
// explicitly via saveUserConsent(uid, type) on an active accept gesture (never silent).
const CONSENT_VERSION = '2026-05-15';

export const saveUserConsents = async (uid, consentVersion) => {
  const { singleUserRef } = firebase;
  const ts = new Date().getTime();
  const version = consentVersion || CONSENT_VERSION;
  const consents = {
    tos: { accepted: true, version, acceptedAt: ts },
    kvkk: { accepted: true, version, acceptedAt: ts }
  };
  await update(singleUserRef(uid), { consents });
  return consents;
};

// Record a single explicit consent (e.g. the courier agreement) without
// overwriting previously stored consents. Merges into the existing consents node
// via a child-path update.
export const CONSENT_TYPES = ['tos', 'kvkk', 'courier'];
export const saveUserConsent = async (uid, type, consentVersion) => {
  // Whitelist guard: prevents an unexpected/path-bearing `type` from writing to
  // an arbitrary nested location under the user node (defense-in-depth).
  if (!CONSENT_TYPES.includes(type)) {
    throw new Error(`saveUserConsent: invalid consent type "${type}"`);
  }
  const { singleUserRef } = firebase;
  const ts = new Date().getTime();
  const version = consentVersion || CONSENT_VERSION;
  const entry = { accepted: true, version, acceptedAt: ts };
  await update(singleUserRef(uid), { [`consents/${type}`]: entry });
  return entry;
};

export const deleteUser = (uid) => (dispatch) => {

  const {
    auth,
    walletHistoryRef,
    singleUserRef,
    userNotificationsRef,
    carsRef,
    carEditRef
  } = firebase;

  dispatch({
    type: DELETE_USER,
    payload: uid
  });

  if (auth.currentUser.uid === uid) {
    off(singleUserRef(uid));
    off(walletHistoryRef(uid));
    off(userNotificationsRef(uid));
  }

  onValue(singleUserRef(uid), userdata => {
    const profile = userdata.val();
    if(profile.usertype === 'driver'){
      onValue(carsRef(uid, profile.usertype), carssnapshot => {
        let cars = carssnapshot.val();
        if (cars) {
          const arr = Object.keys(cars);
          for(let i = 0; i < arr.length; i++){
            remove(carEditRef(arr[i]));
          }
        }
      });
    } 
    
    remove(singleUserRef(uid)).then(() => {
      if (auth.currentUser.uid === uid) {
        signOut(auth);
        dispatch({
          type: USER_DELETED,
          payload: null
        });
      } else {
        remove(singleUserRef(uid)).then(() => {
          dispatch({
            type: DELETE_USER_SUCCESS,
            payload: null
          });
        }).catch((error) => {
          dispatch({
            type: DELETE_USER_FAILED,
            payload: error
          });
        });
      }
    });
  },{onlyOnce:true});
}
